// Client Logos Configuration
// Loading REAL logos from /app/frontend/public/assets/clients/
// Make sure files exist in GitHub repo: calspark-website/frontend/public/assets/clients/

export const clients = [
  {
    name: 'AVAADA',
    fileName: 'avaada.jpg',
    projectType: '220kV Bay Extension – Renewable Energy'
  },
  {
    name: 'Dalmia Bharat',
    fileName: 'dalmia-bharat.jpg',
    projectType: 'Industrial Electrical Works'
  },
  {
    name: 'Aditya Birla',
    fileName: 'ultratech-cement.jpg',
    projectType: 'Cement Plant E&I Works'
  },
  {
    name: 'KMF',
    fileName: 'kmf.png',
    projectType: 'Industrial Electrical Installation'
  },
  {
    name: 'SMBT Sugar',
    fileName: 'SMBT.png',
    projectType: 'Sugar Plant HT/LT Panel Erection'
  },
  {
    name: 'Chettinad Cement',
    fileName: 'chettinad-cement.png',
    projectType: 'Industrial Power Infrastructure'
  },
  {
    name: 'JK Tyre Industries',
    fileName: 'jk-tyre.jpg',
    projectType: 'Industrial Electrical Systems'
  },
  {
    name: 'Maashree Distillery',
    fileName: 'maashree-distillery.png',
    projectType: 'Distillery Plant E&I Works'
  },
  {
    name: 'Oriana Power',
    fileName: 'oriana-power.gif',
    projectType: 'Rooftop Solar I&C Works'
  },
];

// IMPORTANT: These files must exist in your GitHub repo at:
// calspark-website/frontend/public/assets/clients/
// 
// After uploading to GitHub, redeploy the app to see the real logos
